import React, { useContext, useMemo, useState } from 'react';
import { Breadcrumb } from 'antd';
import { getRouteDetails } from '../navigation';
import { getString } from '@nackle/intl-tools';
import { useCookies } from 'react-cookie';

export const PAGE_LEVEL = {
    TOP_LEVEL: 0,
    FIRST_LEVEL: 1,
    SECOND_LEVEL: 2,
};

const BREADCRUMBS = 'breadcrumbs';

export const BreadcrumbContext = React.createContext( [] );

export function BreadcrumbProvider( { children } ) {

    const [ cookies, setCookie, removeCookie ] = useCookies( [ BREADCRUMBS ] );

    const [ crumbStack, setCrumbStack ] = useState( cookies[ BREADCRUMBS ] ?? [] );

    function leaveCrumb( key, title ) {

        const routeData = getRouteDetails( key );

        const crumb = { 
            key, 
            level: routeData.pageLevel,
            title,
            titleKey: routeData.translationKey,
            link: location.pathname };

        const tempCrumbs = crumbStack.filter( c => c.level < crumb.level );

        tempCrumbs.push( crumb );

        setCrumbStack( tempCrumbs );

        let expires = new Date();
        expires.setTime( expires.getTime() + 600 * 1000 );
        setCookie( BREADCRUMBS, JSON.stringify( tempCrumbs ), { path: location.pathname, expires } );
    }

    function clearCrumbs() {
        removeCookie( BREADCRUMBS );
    }


    return <BreadcrumbContext.Provider value={ { leaveCrumb, breadcrumbs: crumbStack, clearCrumbs } }>{ children }</BreadcrumbContext.Provider>;
}

export function useBreadcrumbs() {
    const { breadcrumbs } = useContext( BreadcrumbContext );

    function getTitle( crumb ) {
        return crumb.title ?? getString( crumb.titleKey );
    }

    return useMemo( () =>
        <Breadcrumb separator=">" className="border-bottom breadcrumbs">
            { breadcrumbs.map( ( c, i ) => (
                ( i < breadcrumbs.length - 1 ) ?
                    <Breadcrumb.Item key={ c.key } className='clickable' onClick={ () => location.href = c.link }>{ getTitle( c ) }</Breadcrumb.Item> :
                    <Breadcrumb.Item key={ c.key }>{ getTitle( c ) }</Breadcrumb.Item>
            ) ) }
        </Breadcrumb>
    , [ breadcrumbs ] );
}